// Shared `PrintLabels.*` i18n keys (used by PrintLabelsDialog.vue, which is
// mounted by WineDetail.vue). Only the actively-referenced keys are kept; the
// legacy `selectedScope` / `allScope` / `bottles` / `noPrintable` / `print`
// entries were hardcoded in the dialog and have been dropped.

export const printLabelsDict: Record<string, [en: string, th: string]> = {
  "PrintLabels.title": ["Print Labels", "พิมพ์ฉลาก"],
  "PrintLabels.labels": ["labels", "ฉลาก"],
  "PrintLabels.mode.roll": ["Roll Sticker (Zebra)", "Roll Sticker (Zebra)"],
  "PrintLabels.mode.a4": ["A4 Sheet", "A4 Sheet"],
  "PrintLabels.size.sm": ["20×20mm — Neck (คอขวด)", "20×20mm — คอขวด (Neck)"],
  "PrintLabels.size.md": ["25×25mm — Back Label (ฉลากหลัง)", "25×25mm — ฉลากหลัง (Back)"],
  "PrintLabels.size.lg": ["30×35mm — Back Label (ฉลากหลัง)", "30×35mm — ฉลากหลัง (Back)"],
  "PrintLabels.size.fixed": ["73×17mm", "73×17mm"],
  "PrintLabels.action.standard": ["Print Label", "พิมพ์ฉลาก"],
  "PrintLabels.action.rfid": ["Print RFID", "พิมพ์ RFID"],
};
